import { API_URL } from '../Config.js';

const apiUrl = API_URL 

const getRutaReportServerList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}Formularios/GetReportServer`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

const UpdateGroup = async (codEntidad, rowId, newReporte, newGroupValue, accessToken) => {
    const url = `${apiUrl}Formularios/spUpdateGroup`;
  
    const data = {
      spUpdateGroupRequest: {
        CodEntidad: codEntidad,
        Id: rowId,
        Reporte: newReporte,
        NuevoGroup: newGroupValue,
      },
    };
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      });
  
      if (response.ok) {
        return { success: true, message: 'Actualización exitosa' };
      } else {
        console.error('Error en la respuesta:', response.status, response.statusText);
        return { success: false, message: 'Falló la actualización' };
      }
    } catch (error) {
      console.error('Error en UpdateGroup:', error.message);
      throw error;
    }
};
  

const UpdateReportServer = async (codEntidad, rowId, newReporte, newGroupValue, newActivo, accessToken) => {
  const url = `${apiUrl}Formularios/spUpdateReportServer`;
  
  const data = {
    spUpdateReportServerRequest: {
      codEntidad: codEntidad,
      id: rowId,
      reporte: newReporte,
      nuevoGroup: newGroupValue,
      activo: newActivo
    },
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      return { success: true, message: 'Actualización exitosa' };
    } else {
      console.error('Error en la respuesta:', response.status, response.statusText);
      return { success: false, message: 'Falló la actualización' };
    }
  } catch (error) {
    console.error('Error en UpdateGroup:', error.message);
    throw error;
  }
  };


export { getRutaReportServerList, UpdateGroup, UpdateReportServer}